<template>
    <v-container>
        <v-card width="100%">
            <span class='headline'>Latest Submissions</span> | 
            <router-link :to="'/newest/' + (page-1)"><v-icon v-if="page>1" @click="previousPage()">chevron_left</v-icon> </router-link>
            <span class='headline'>Page {{ page }} </span>
            <router-link :to="'/newest/' + (parseInt(page)+1)"><v-icon @click="nextPage()">chevron_right</v-icon></router-link>
        </v-card>
        <v-container fluid grid-list-md>
            <v-layout row wrap v-if="this.Girls.length>0">
                <v-flex xs6 md4 lg3 xl2  v-for="(Girl,i) in getGirlsWithThumbs" :key="i">
                    <router-link :to="getImageLink(i)">    
                        <v-card>
                            <v-img style="z-index: 1; background-color: white;" height="300" @error="hideme(i)" :src="Girl.ImageURL"></v-img>
                            <v-card-title class='headline'>{{ Girl.Name }} 
                                <v-badge><span slot="badge">{{ Girl.ImageCount }}</span></v-badge>
                            </v-card-title>
                        </v-card> 
                    </router-link>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>
</template>

<script>
    import axios from 'axios'
    /* eslint no-console: 0 */

    export default {
        components: {
        },
        data: function() {
            return {
                Girls: [],
                page: 1,
            }
        },
        watch: {
            '$route': function() {
                this.page = this.$route.params.page;
                this.getNewest();
            }

        },
        beforeCreate: function() {
                this.page = this.$route.params.page;
        },
        mounted: function() {
            if (this.$route.params.page)
                this.page = this.$route.params.page;
              this.$nextTick(function () {
                    if (window.themodels && window.themodels.length!=0) {
                        var tmp={};
                        tmp.data=[];
                        for (var key in window.themodels) {
                            tmp.data.push(window.themodels[key])
                        }
                    this.gotNewest(tmp);
                    window.themodels=[];
                    } else this.getNewest();
              });        
        },

        methods: {
            getNewest: function() {
                axios.get("https://cdn.gonewildreplay.com/cdn/getNewest/" + this.page).then(this.gotNewest);
            },
            gotNewest: function(response) {
                this.Girls = response.data;

            },
            hideme: function(i) {
                var tmp = [];
                for (var key in this.Girls) {
                    if (key != i) {
                        tmp.push(this.Girls[key])
                    }
                }
                this.Girls = tmp;
            },
            gotclick: function(i) {
                this.$router.push("/girl/" + this.Girls[i].Name);
            },


            previousPage: function() {
                var tmp = this.page - 1;
                if (tmp < 1) tmp = 1;
                this.page = tmp;
                this.$router.push("/newest/" + this.page)
            },
            nextPage: function() {
                this.page++;
                
                this.$router.push("/newest/" + this.page)
            },
            getImageLink: function(key) {
                var link="/girl/" + this.Girls[key].Name;

                return link
            },
           getGirlsWithThumbsFunc: function() {
                var x = [];
                for (var key in this.Girls) {
                    var g = {}
                    g.Name = this.Girls[key].Name;
                    g.ImageURL = "https://cdn.gonewildreplay.com/cdn/thumb/" + this.Girls[key].ImageURL;
                    g.ImageCount = this.Girls[key].ImageCount;
                    x.push(g);
                }
                return (x);
            }

 
        },
        computed: {
            getGirlsWithThumbs: function() {
                var x = [];
                for (var key in this.Girls) {
                    var g = {}
                    g.Name = this.Girls[key].Name;
                    g.ImageURL = "https://cdn.gonewildreplay.com/cdn/thumb/" + this.Girls[key].ImageURL;
                    g.ImageCount = this.Girls[key].ImageCount;
                    x.push(g);
                }
                return (x);
            }
        }

    }
</script>

<style>
a:link {
    text-decoration: none;
}

</style>
